export default "__VITE_ASSET__huoUtFDW__"